













import { Vue, Prop, Component } from 'vue-property-decorator'
import InsideBarChart from '@/components/g2Charts/chartList/insideBarChart'
@Component({
  components: {
    InsideBarChart
  }
})
export default class InsideBarChartWrap extends Vue {
  @Prop() data!: [];
  @Prop() options!: {};
}
